<script lang="ts">
    import EmployeesViewComponent from '../../components/employer/employees/EmployeesView.svelte';

    // Get the ID from the route params store
    export let params: { id?: string } = {};

</script>

<EmployeesViewComponent employeeId={params.id || ''} />